import styled from '@emotion/styled';

export const StyledFullWidth = styled.div`
  width: 100%;

  .total-count {
    font-size: 14px;
    margin-bottom: 10px;
  }

  table {
    width: 100%;
    tbody > tr > td {
      background-color: #fafafa;
    }
  }
`;

export const StyledStatus = styled.span`
  &.complete {
    color: #6494e2;
  }

  &.failed {
    color: #f68557;
  }
`;

export const StyledHiddenTodos = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;

  .hidden-content {
    position: absolute;
    top: 0;
    left: 100%;
  }
`;

export const StyledTodosPDF = styled.div`
  width: 297mm;
  height: 210mm;
  margin: 0 auto;
  background-color: transparent;

  table {
    width: 100%;
    height: 100%;

    tbody > tr {
      height: 24px;
      line-height: 1;
      background-color: transparent;

      td {
        background-color: transparent;
      }
    }
  }

  & + div {
    margin-top: 20px;
  }
`;

export const StyledTextOverflow = styled.div`
  max-width: 150px;
  width: 150px;
  text-align: center;
  word-break: break-all;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
